import { connect } from 'react-redux';
import { redux } from '../api';

import DemoForm from './DemoForm.js';

const { setAiHeatmapDataSource } = redux.actions;
const isActive = a => a.active === true;

const mapStateToProps = state => {
  const activeServer = state.servers.servers.find(isActive);
  return {
    viewportData: state.viewports.viewportSpecificData,
    context: state.ui.heatmapContext,
    server: activeServer,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setHeatmapDataSource: data => {
      dispatch(setAiHeatmapDataSource(data));
    },
  };
};

const ConnectedDemoForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(DemoForm);

export default ConnectedDemoForm;
